<script setup lang="ts">
import Advantages from '~/components/homepage/advantages/Advantages.vue';
import About from '~/components/homepage/about/About.vue';
import Hero from '~/components/homepage/hero/Hero.vue';
import Services from '~/components/homepage/services/Services.vue';
import RunLine from '~/components/homepage/runline/RunLine.vue';
</script>

<template>
    <div class="page">
        <Hero />
        <Advantages v-if="false" data-aos="fade-up" />
        <About data-aos="fade-up" />
        <RunLine v-if="false" data-aos="fade-up" />
        <Services data-aos="fade-up" />
    </div>
</template>

<style scoped lang="scss">
</style>
